import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Api from '../../api/api';
import DinamicTable from '../common/dinamic-table';
import OverlayLoading from '../common/overlay-loading';

export default class Distribute extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modal: false,
            id: null,
            form: {
                amount: '',
                totalDays: 0,
                currentDay: 0,
                amountRemaining: '',
            }
        }
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        await this.setState({ loading: true });
        const req = await Api.get('distributes');
        if (!req.error) {
            const rows = req.data;
            const cols = [
                'Amount',
                'Total Days',
                'Current Day',
                'Amount Remaining',
                'Last Distribute',
                'Created',
                '<button>Edit'
            ];
            const formattedRows = rows.map(row => [
                (parseFloat(row.amount) / 1e9).toFixed(4),
                row.totalDays,
                row.currentDay,
                (parseFloat(row.amountRemaining) / 1e9).toFixed(4),
                row.lastDistribute ? new Date(row.lastDistribute).toLocaleString() : '',
                new Date(row.created).toLocaleString(),
                row
            ]);
            this.table.updateTable(cols, formattedRows);
        }
        await this.setState({ loading: false });
    }

    openRow = (row) => {
        this.setState({
            modal: true,
            id: row.id,
            form: {
                amount: (parseFloat(row.amount) / 1e9).toFixed(9),
                totalDays: row.totalDays,
                currentDay: row.currentDay,
                amountRemaining: (parseFloat(row.amountRemaining) / 1e9).toFixed(9),
            }
        });
    }

    newRow = () => {
        this.setState({
            modal: true,
            id: null,
            form: {
                amount: '0',
                totalDays: 0,
            }
        });
    }

    saveRow = async () => {
        await this.setState({ loading: true });
        const form = {
            amount: (parseFloat(this.state.form.amount) * 1e9).toFixed(0),
            totalDays: parseInt(this.state.form.totalDays),
            currentDay: 0,
            amountRemaining: '',
        };
        if (this.state.id) {
            form.currentDay = parseInt(this.state.form.currentDay);
            form.amountRemaining =  (parseFloat(this.state.form.amountRemaining) * 1e9).toFixed(0);
            await Api.patch(`distributes/${this.state.id}`, form);
        } else {
            form.currentDay = 0;
            form.amountRemaining = form.amount;
            await Api.post('distributes', form);
        }
        this.updateTable();
        this.setState({ modal: false, loading: false });
    }

    distributeItem = async () => {
        if (this.state.id) {
            await this.setState({ loading: true });
            await Api.post(`distributes/${this.state.id}/distribute`);
            this.updateTable();
            this.setState({ modal: false, loading: false });
        }
    }

    deleteRow = async (id) => {
        const response = window.confirm("Você tem certeza que deseja deletar esta distribuição?");
        if (response) {
            await Api.del(`distributes/${id}`);
            this.updateTable();
            this.setState({ modal: false });
        }
    }

    handleChange = (event) => {
        const form = this.state.form;
        form[event.target.name] = event.target.value;
        this.setState({ form });
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal });
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Distribuições</h5>
                                        </div>
                                        <div className="col">
                                            <div className="pull-right right-header">
                                                <button className="btn btn-primary" onClick={this.newRow}>Criar Novo</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DinamicTable
                                    size="5"
                                    ref={ref => this.table = ref}
                                    openRow={this.openRow}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg" centered>
                    <ModalHeader toggle={this.toggleModal}>{this.state.id ? 'Editar' : 'Novo'} Distribuição</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Amount</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="amount"
                                        value={this.state.form.amount}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Total Days</label>
                                    <input
                                        className="form-control"
                                        type="number"
                                        name="totalDays"
                                        value={this.state.form.totalDays}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {this.state.id && <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Current Day</label>
                                    <input
                                        className="form-control"
                                        type="number"
                                        name="currentDay"
                                        value={this.state.form.currentDay}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Amount Remaining</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="amountRemaining"
                                        value={this.state.form.amountRemaining}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>}
                    </ModalBody>
                    <ModalFooter>
                        <div className='row w-100'>
                            <div className='col-md text-left'>
                                {this.state.id && <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={() => this.deleteRow(this.state.id)}>Deletar</button>}
                            </div>
                            <div className='col-md text-center'>
                                {this.state.id && <button className="btn btn-warning" style={{ marginRight: '10px' }} onClick={this.distributeItem}>Distribute</button>}
                            </div>
                            <div className='col-md' style={{ textAlign: 'right' }}>
                                <button className="btn btn-primary" onClick={this.saveRow}>Salvar</button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}
